import css from "styled-jsx/css";
import colors from "styles/colors";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";

// We put here styles that we can't manipulate straight from the react-select component styles prop (see react-select-styles.js)
export const componentStyles = css.global`
  .hp-multi-select-input {
    .action-indicator {
      display: flex;
      align-items: center;
      stroke: rgba(0, 0, 0, 0.7);

      &:hover {
        stroke: rgba(0, 0, 0, 1);
      }
    }

    .multi-select-custom-option {
      display: flex;
      align-items: center;

      .custom-checkbox {
        margin-right: 10px;
        width: 18px;
        height: 18px;
        background-color: white;
        border: 1px solid #cbcbcb;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.selected {
          background-color: ${colors[WORK_OS_IRIS_COLOR_NAME]};
          border: none;
        }
      }
    }
  }
`;
